import { AuthService } from '../services/auth.service';

/**
 * Auth + timezone headers, attached explicitly per request.
 *
 * AuthContext also sets axios.defaults.headers.common['X-Timezone'], but that cannot be relied
 * on: it is set in the provider's useEffect, and React runs child effects BEFORE parent effects,
 * so a screen's fetch-on-mount races ahead of it and goes out bare. A POS report that loses its
 * timezone shows a UTC+6 tenant the previous day's takings between midnight and 06:00 local.
 * dashboard.service.ts does the same thing for the same reason.
 */
export const tzHeaders = () => ({
    ...AuthService.getAuthHeader(),
    'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
});
